export default __webpack_public_path__ + "static/media/completeIcon.605ca8f9.svg";